module.exports = __webpack_public_path__ + "img/1ne.112c7b45.svg";